import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { useLiveViewContext } from "./LiveViewContext";
import { firstNameOf } from "./stageNotice";
import { LiveDot } from "./LiveDot";

/**
 * On the applicant's report: "Jane is in the application now · Income" and
 * "View live", while they are. Nothing otherwise (the overview shows the
 * disabled button), and never for manual applications.
 */
export const ApplicantLiveViewBanner = ({
  applicantId,
  applicantName,
  isManual
}: {
  applicantId: number;
  applicantName: string;
  isManual: boolean;
}) => {
  const liveView = useLiveViewContext();
  const entry = isManual ? undefined : liveView?.presence.get(applicantId);
  if (!liveView || !entry) return null;

  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border border-success-100 bg-success-50 px-4 py-3 print:hidden">
      <p className="flex min-w-0 items-center gap-2 text-sm font-medium text-success-700">
        <LiveDot />
        <span className="truncate">
          {firstNameOf(applicantName)} is in the application now · {entry.step}
        </span>
      </p>
      <Button
        size={ButtonSize.SM}
        variant={ButtonVariant.BASE}
        className="shrink-0"
        onClick={() => liveView.watch({ id: applicantId, name: applicantName })}
      >
        View live
      </Button>
    </div>
  );
};
